module.exports = __webpack_public_path__ + "img/overlayLogin.0eb26669.png";